export default {
  data() {
    return {
      validacaoId: "especialidadesServicosPrestados",
      errors: {
        especialidades: "Esse campo é obrigatório!",
        demaisServicos: ""
      }
    };
  },
  computed: {
    temErrors() {
      let temErro = false;

      Object.values(this.errors).forEach(err => {
        if (err) {
          temErro = true;
        }
      });

      return temErro;
    }
  },
  methods: {
    validate(campo) {
      if (campo === "especialidades") {
        if (this.especialidadesServicosPrestados.especialidades) {
          return (this.errors.especialidades = "");
        } else {
          return (this.errors.especialidades = "Esse campo é obrigatório!");
        }
      }
    }
  },
  watch: {
    temErrors(boo) {
      const payload = {
        temErro: boo,
        validacaoId: this.validacaoId
      };
      this.$emit("error", payload);
    }
  }
};
